import MessagesScreen from "../components/Messages/Messages";

const MessagesPage = () => {
  return <MessagesScreen />;
};

export default MessagesPage;
